export enum CaptureAngle {
  Front,
  Left,
  Right,
  Top,
  Hero,
}

export interface StepConfig {
  gifSource: string;
  index: string;
  angles: CaptureAngle[];
  filenames: string[];
}

export const laptopSteps: StepConfig[] = [
  {
    gifSource: "/videos/photo-booth/laptop/step-1.webm",
    index: "1",
    angles: [CaptureAngle.Front, CaptureAngle.Right, CaptureAngle.Left, CaptureAngle.Top, CaptureAngle.Hero],
    filenames: ["front_edge", "right_edge", "left_edge", "top_face", "top_angle"],
  },
  {
    gifSource: "/videos/photo-booth/laptop/step-2.webm",
    index: "2",
    angles: [CaptureAngle.Hero, CaptureAngle.Top],
    filenames: ["hero", "keyboard"],
  },
  {
    gifSource: "/videos/photo-booth/laptop/step-3.webm",
    index: "3",
    angles: [CaptureAngle.Top, CaptureAngle.Front],
    filenames: ["bottom_face", "back_edge"],
  },
];

export const miniDesktopSteps: StepConfig[] = [
  {
    gifSource: "/videos/photo-booth/minipc/step-1.webm",
    index: "1",
    angles: [CaptureAngle.Front, CaptureAngle.Right, CaptureAngle.Left, CaptureAngle.Top],
    filenames: ["front_face", "right_face", "left_face", "top_face"],
  },
  {
    gifSource: "/videos/photo-booth/minipc/step-2.webm",
    index: "2",
    angles: [CaptureAngle.Front, CaptureAngle.Top],
    filenames: ["rear_face", "bottom_face"],
  },
];

export const tabletSteps: StepConfig[] = [
  {
    gifSource: "/videos/photo-booth/tablet/step-1.webm",
    index: "1",
    angles: [CaptureAngle.Front, CaptureAngle.Right, CaptureAngle.Left, CaptureAngle.Top],
    filenames: ["bottom_edge", "right_edge", "left_edge", "screen_face"],
  },
  {
    gifSource: "/videos/photo-booth/tablet/step-2.webm",
    index: "2",
    angles: [CaptureAngle.Front, CaptureAngle.Top],
    filenames: ["top_edge", "rear_face"],
  },
];
